import React from 'react';

import ContentController from 'RLX/Controllers/ContentController';

class HtmlEditor extends ContentController {
  static getInitialShape () {
    return {
      props: {
        src: null
      }
    };
  }

  getClassName () {
    return 'HtmlEditor';
  }

  getBlockName () {
    return 'Raw HTML Block';
  }

  getFields () {
    const faded = { opacity: 0.5 };
    const { content } = this.props;
    return [
      [
        {
          content: (
            <div
              style={{width:'100%'}}
              dangerouslySetInnerHTML={{ __html: content.props.content }}
            />
          )
        }
      ],
      [
        {
          type: 'html',
          icon: 'code',
          required: true,
          label: 'Custom HTML',
          value: content.props.content,
          onChange: this.applyUpdate((content, existing) => {
            const { props } = existing;
            return { ...existing, props: { ...props, content } };
          })
        }
      ]
    ]
  };
};

export default HtmlEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Editors/HtmlEditor.jsx